import {
  USER_ID_PROJECT_FAIL,
  USER_ID_PROJECT_REQUEST,
  USER_ID_PROJECT_SUCCESS,
  USER_ID_PROJECT_TIME_FAIL,
  USER_ID_PROJECT_TIME_REQUEST,
  USER_ID_PROJECT_TIME_SUCCESS,
  USER_ID_MONTH_PROJECT_TIME_FAIL,
  USER_ID_MONTH_PROJECT_TIME_REQUEST,
  USER_ID_MONTH_PROJECT_TIME_SUCCESS,
  USER_ID_ALL_PROJECT_FAIL,
  USER_ID_ALL_PROJECT_REQUEST,
  USER_ID_ALL_PROJECT_SUCCESS,
  USER_ID_PROJECT_ALL_BY_DATE_TIME_FAIL,
  USER_ID_PROJECT_ALL_BY_DATE_TIME_REQUEST,
  USER_ID_PROJECT_ALL_BY_DATE_TIME_SUCCESS,
  USER_ID_RANGE_PROJECT_TIME_FAIL,
  USER_ID_RANGE_PROJECT_TIME_REQUEST,
  USER_ID_RANGE_PROJECT_TIME_SUCCESS,
  USER_ID_PROJECT_DELETE_FAIL,
  USER_ID_PROJECT_DELETE_REQUEST,
  USER_ID_PROJECT_DELETE_SUCCESS,
  USER_ID_PROJECT_TIME_DELETE_FAIL,
  USER_ID_PROJECT_TIME_DELETE_REQUEST,
  USER_ID_PROJECT_TIME_DELETE_SUCCESS,
  USER_DELETE_FROM_PROJECT_FAIL,
  USER_DELETE_FROM_PROJECT_REQUEST,
  USER_DELETE_FROM_PROJECT_SUCCESS,
} from "../../types/admin/projectType";

export const projectTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_PROJECT_TIME_REQUEST:
      return {
        ...state,
        projectLoading: true,
      };
    case USER_ID_PROJECT_TIME_SUCCESS:
      return {
        ...state,
        projectLoading: false,
        projectTimerInfo: payload,
        projectError: "",
      };
    case USER_ID_PROJECT_TIME_FAIL:
      return {
        ...state,
        projectLoading: false,
        projectTimerInfo: [],
        projectError: payload,
      };
    default:
      return state;
  }
};

export const projectAllDatedTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_PROJECT_ALL_BY_DATE_TIME_REQUEST:
      return {
        ...state,
        proAllDateLoading: true,
      };
    case USER_ID_PROJECT_ALL_BY_DATE_TIME_SUCCESS:
      return {
        ...state,
        proAllDateLoading: false,
        proAllDateTimerInfo: payload,
        proAllDateError: "",
      };
    case USER_ID_PROJECT_ALL_BY_DATE_TIME_FAIL:
      return {
        ...state,
        proAllDateLoading: false,
        proAllDateTimerInfo: [],
        proAllDateError: payload,
      };
    default:
      return state;
  }
};

export const projectMothTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_MONTH_PROJECT_TIME_REQUEST:
      return {
        ...state,
        monthProjectLoading: true,
      };
    case USER_ID_MONTH_PROJECT_TIME_SUCCESS:
      return {
        ...state,
        monthProjectLoading: false,
        monthProjectTimerInfo: payload,
        monthProjectError: "",
      };
    case USER_ID_MONTH_PROJECT_TIME_FAIL:
      return {
        ...state,
        monthProjectLoading: false,
        monthProjectTimerInfo: [],
        monthProjectError: payload,
      };
    default:
      return state;
  }
};

export const projectRangeTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_RANGE_PROJECT_TIME_REQUEST:
      return {
        ...state,
        rangeProjectLoading: true,
      };
    case USER_ID_RANGE_PROJECT_TIME_SUCCESS:
      return {
        ...state,
        rangeProjectLoading: false,
        rangeProjectTimerInfo: payload,
        rangeProjectError: "",
      };
    case USER_ID_RANGE_PROJECT_TIME_FAIL:
      return {
        ...state,
        rangeProjectLoading: false,
        rangeProjectTimerInfo: [],
        rangeProjectError: payload,
      };
    default:
      return state;
  }
};

export const ProjectReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_PROJECT_REQUEST:
      return {
        ...state,
        ProLoading: true,
      };
    case USER_ID_PROJECT_SUCCESS:
      return {
        ...state,
        ProLoading: false,
        ProInfo: payload,
        ProError: "",
      };
    case USER_ID_PROJECT_FAIL:
      return {
        ...state,
        ProLoading: false,
        ProTimerInfo: [],
        ProError: payload,
      };
    default:
      return state;
  }
};

export const ProjectAllReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_ALL_PROJECT_REQUEST:
      return {
        ...state,
        ProAllLoading: true,
      };
    case USER_ID_ALL_PROJECT_SUCCESS:
      return {
        ...state,
        ProAllLoading: false,
        ProAllInfo: payload,
        ProAllError: "",
      };
    case USER_ID_ALL_PROJECT_FAIL:
      return {
        ...state,
        ProAllLoading: false,
        ProAllInfo: [],
        ProAllError: payload,
      };
    default:
      return state;
  }
};

export const projectTimeDeleteReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_PROJECT_TIME_DELETE_REQUEST:
      return {
        ...state,
        projTimeDelLoading: true,
      };
    case USER_ID_PROJECT_TIME_DELETE_SUCCESS:
      return {
        ...state,
        projTimeDelLoading: false,
        projTimeDelInfo: payload,
        projTimeDelError: "",
      };
    case USER_ID_PROJECT_TIME_DELETE_FAIL:
      return {
        ...state,
        projTimeDelLoading: false,
        projTimeDelInfo: [],
        projTimeDelError: payload,
      };
    default:
      return state;
  }
};

export const projectDeleteReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_PROJECT_DELETE_REQUEST:
      return {
        ...state,
        projDelLoading: true,
      };
    case USER_ID_PROJECT_DELETE_SUCCESS:
      return {
        ...state,
        projDelLoading: false,
        projDelInfo: payload,
        projDelError: "",
      };
    case USER_ID_PROJECT_DELETE_FAIL:
      return {
        ...state,
        projDelLoading: false,
        projDelInfo: [],
        projDelError: payload,
      };
    default:
      return state;
  }
};

export const userDeleteFromProjectReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_DELETE_FROM_PROJECT_REQUEST:
      return {
        ...state,
        userDelProjLoading: true,
      };
    case USER_DELETE_FROM_PROJECT_SUCCESS:
      return {
        ...state,
        userDelProjLoading: false,
        userDelProjInfo: payload,
        userDelProjError: "",
      };
    case USER_DELETE_FROM_PROJECT_FAIL:
      return {
        ...state,
        userDelProjLoading: false,
        userDelProjInfo: [],
        userDelProjError: payload,
      };
    default:
      return state;
  }
};
